export const AIR_SEATS_ROUTES = {
  confirmation: "/air/seat/confirmation",
  purchase: "/air/seat/purchase",
  select: "/air/seat/select-seats",
  view: "/air/seat/view-seats",
};
